module.exports = __webpack_public_path__ + "vodafone-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/vodafone-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/vodafone-logo.png
// module chunks = 12